import React from "react"

import { CircularProgress, styled } from '@material-ui/core';

import { RouteComponentProps, navigate } from "@reach/router";
import { RootState } from '../store';
import { useSelector } from "react-redux";




interface PrivateRouteProps extends RouteComponentProps {
  component: any;
}


const LogoContainer = styled('div')({
  width: '100vw',
  height: '100vh',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',

})



const PrivateRoute: React.FC<PrivateRouteProps> = ({ component: Component, location, ...rest }) => {
  const user = useSelector((state: RootState) => state.auth);

  if (user.userStateLoading || !location) {
    return (
      <LogoContainer>
        <CircularProgress size={50}/>
      </LogoContainer>
    );
  }

  if ((user.user === null || user.user.roles.length === 0) && location.pathname !== '/sign-in') {
    navigate('/sign-in');
    return null;
  }

  return <Component {...rest} />

};

export default PrivateRoute;